(function () {

  'use strict';

  angular.module('eclipseApp.user').service('janrainService', ['$translate', '$window', '$state', '$rootScope', 'uteModal', 'env', 'flowMaintenanceService', '$timeout', '$location',
    function ($translate, $window, $state, $rootScope, uteModal, env, flowMaintenanceService, $timeout, $location) {

      // this.ssoFinished = false;

      // this.ssoFinishedCallback = {};
      // this.ssoFinishedCallbackDone = false;
      //
      // this.janrainStatus = {
      //   linkExpired: false,
      //   loginRendered: false,
      //   /* login is rendered or not*/
      //   successErrorMessage: false,
      //   /* weather to display error/success message */
      //   janrainMessage: '' /* set message here */
      // };

      // this.SecurityQA = {
      //   "What is your mother’s maiden name?": "Quel est le nom de jeune fille de votre mère?",
      //   "What city were you born in?": "Quelle est votre ville natale?",
      //   "What was the name of your first pet?": "Quel était le nom de votre premier animal domestique?",
      //   "What was the name of your high school?": "Quel était le nom de votre école secondaire?",
      //   "What is your favourite sports team?": "Quelle est votre équipe sportive préférée?",
      //   "What was the name of your favourite teacher?": "Quel était le nom de votre professeur(e) favori(te)?",
      //   "What is your favourite pastime?": "Quel est votre passe-temps favori?",
      //   "What was your first vacation spot?": "Où avez-vous passé vos premières vacances?"
      // };

      /* we have to manipulate dom here */
      // this.focusElement = function (screenName, elementName) {
      //   console.log('focusing element', screenName, elementName);
      //   if (screenName == "signIn" && elementName == "userID") {
      //
      //   } else {
      //     var e = $('#capture_' + screenName + '_' + elementName);
      //     e.focus();
      //     e.val(e.val());
      //   }
      //
      // };

      // this.showErrorMessage = function (message) {
      //   $('.capture_rightText .capture_secondary').show();
      //   $('.capture_rightText .capture_processing').hide();
      //   this.clearPasswordField();
      //
      //
      //   if ($('#capture_signIn_signInForm_errorMessages').children().first().length) {
      //     // $('#capture_signIn_signInForm_errorMessages').children().first().html(message);
      //     $('#capture_signIn_signInForm_errorMessages').children().first().html($compile(message)($rootScope));
      //   } else {
      //     message = '<div data-capturefield="undefined" class="capture_form_error capture_formerror_1426861805991" id="capture_signIn_formerror_1426861805991">' + message + '</div>';
      //     // $('#capture_signIn_signInForm_errorMessages').html(message);
      //     $('#capture_signIn_signInForm_errorMessages').html($compile(message)($rootScope));
      //   }
      //
      //
      // };

      /*FUSS-2917- TO Display specific error message when customers attempt
       log in with their CTN after they've migrated to email address */
      // this.showMigratedErrorMessage = function (message) {
      //   $('.capture_rightText .capture_secondary').show();
      //   $('.capture_rightText .capture_processing').hide();
      //   this.clearPasswordField();
      //
      //   if ($('#capture_signIn_signInForm_errorMessages').children().first().length) {
      //     $('#capture_signIn_signInForm_errorMessages').children().first().html($compile(message)($rootScope));
      //   } else {
      //     message = '<div data-capturefield="undefined">' + message + '</div>';
      //     $('#capture_signIn_signInForm_errorMessages').html(message);
      //   }
      // };

      /*FUSS-2221-This functionality is to hide default janrain message
        on login failure due to invalidCredentials and to show
        specific error messages to the user*/
      //
      // this.showUsernameOrPasswordIncorrect = function (message) {
      //
      //   $('.capture_rightText .capture_secondary').show();
      //   $('.capture_rightText .capture_processing').hide();
      //   this.clearPasswordField();
      //
      //
      //   if ($('#capture_signIn_signInForm_errorMessages').children().first().length) {
      //     $('#capture_signIn_signInForm_errorMessages').children().first().html($compile(message)($rootScope));
      //     $('#capture_signIn_signInForm_errorMessages').find('a').css('text-decoration', 'none');
      //     $('#capture_signIn_signInForm_errorMessages').show();
      //   }
      //
      // };


      // this.showErrorMessagePWReset = function (message) {
      //
      //
      //   if ($('#capture_forgotPassword_forgotPasswordForm_errorMessages').children().first().length) {
      //     $('#capture_forgotPassword_forgotPasswordForm_errorMessages').children().first().html(message);
      //
      //   } else {
      //     message = '<div data-capturefield="undefined" class="capture_form_error capture_forgotPassword_formerror_1439925927267" id="capture_forgotPassword_formerror_1439925927267">' + message + '</div>';
      //     $('#capture_forgotPassword_forgotPasswordForm_errorMessages').html(message);
      //   }
      //
      // };

      // this.displayMessage = function () {
      //   if (this.janrainStatus.successErrorMessage == true) {
      //     $('#capture_signIn_signInForm_successMessages .capture_form_success').html(this.janrainStatus.janrainMessage);
      //     $('#capture_signIn_signInForm_successMessages').show();
      //     this.janrainStatus.successErrorMessage = false;
      //   } else {
      //
      //     $('#capture_signIn_signInForm_successMessages').hide();
      //
      //   }
      // };
      //
      // this.showSuccessMessageLogout = function (message) {
      //   if (this.janrainStatus.successErrorMessage == true) {
      //     $('#capture_signIn_signInForm_successMessages').html(message);
      //     $('#capture_signIn_signInForm_successMessages').show();
      //     this.janrainStatus.successErrorMessage = false;
      //   } else {
      //     $('#capture_signIn_signInForm_successMessages').hide();
      //   }
      // };
      //
      // /** show success message */
      // this.showSuccessMessage = function (message) {
      //   $('#capture_signIn_signInForm_successMessages').html(message);
      //   $('#capture_signIn_signInForm_successMessages').show();
      //   this.setSuccessErrorMessage(true);
      //
      // };

      /** hide processing only as we make another call after login with janarain */
      // this.hideProcessing = function (message) {
      //   $('.capture_processing').hide();
      //   $('.capture_btn.capture_primary[type="submit"]').css({
      //     display: 'inline-block'
      //   });
      //   //If social login - facebook
      //   var janrainContentDivs = document.getElementById("janrainView").parentNode.childNodes;
      //
      //   if (janrainContentDivs.length == 3) {
      //     document.getElementById("janrainAuthReturnExperience").parentNode.removeChild(janrainContentDivs[2]);
      //     $("#janrainAuthReturnExperience").css({"visibility": "visible"});
      //   } else if (janrainContentDivs.length == 2) {
      //     document.getElementById("janrainView").parentNode.removeChild(janrainContentDivs[1]);
      //     $("#janrainView").css({"visibility": "visible"});
      //   }
      // };

      /** hide success message only */
      // this.hideSuccessMessage = function () {
      //   $('#capture_signIn_signInForm_successMessages').hide();
      // };

      /** hide message when you click again on login button */
      // this.hideAllErrorMessage = function (message) {
      //   $('#capture_signIn_signInForm_errorMessages').hide();
      //   $('.capture_form_error').hide();
      // };

      /** set link expred status here */
      // this.setLinkExpired = function (status) {
      //   this.janrainStatus.linkExpired = 'demo here';
      // };

      // this.closeJanrainModal = function () {
      //   console.log('in janran modal cose');
      //   $window.janrain.capture.ui.modal.close();
      // };

      /** set link expred status here */
      // this.getStatus = function () {
      //   return this.janrainStatus;
      // };

      /** set tue/false here weather to show message when screen is rendered */
      // this.setSuccessErrorMessage = function (status) {
      //   this.janrainStatus.successErrorMessage = status;
      // };

      /** set message here that will be shown in to pop up*/
      // this.setJanrainMessage = function (message) {
      //   this.janrainStatus.janrainMessage = message;
      // };

      /* clear password field when there is error in login widet*/
      // this.clearPasswordField = function () {
      //   if (document.getElementById('capture_signIn_currentPassword') != null) {
      //     document.getElementById('capture_signIn_currentPassword').value = '';
      //   }
      // };

      /* Used to clear local storage value, cannot use ng-storage here*/
      this.clearLocalStorageValue = function () {
        /* set keys that you do not wat to be deleted from local storage*/
        /*FUSS-1509 :retaining remember me checkbox value and user id in localStorage even on logout.*/
        var keepKeys = ['rememberMeValue', 'rememberMeUserID'];
        var keyValue = {};

        $.each(keepKeys, function (index, key) {
          keyValue[key] = $window.localStorage.getItem(key);
        });

        $window.localStorage.clear();

        $.each(keepKeys, function (index, key) {
          // localStorage.setLocalStorageValue(key,keyValue[key]);
          $window.localStorage.setItem(key, keyValue[key]);
        });
      };


      /* checks if janrain is ready and uses callback as function */
      // this.checkJanrainModalReady = function (callback) {
      //
      //   var checkJanrainModalReadyInner = function () {
      //
      //     /* check if ready fire right away */
      //     if (window.janrain.loginUiModalReady == true && janrain.captureReady == true) {
      //       callback();
      //     } else {
      //       setTimeout(function () {
      //         /* make sure janrain capture and janrain login modal is ready */
      //         if (window.janrain.loginUiModalReady == true && janrain.captureReady == true) {
      //           callback();
      //         } else {
      //           checkJanrainModalReadyInner();
      //         }
      //       }, 300);
      //     }
      //   };
      //   checkJanrainModalReadyInner();
      // };

      // this.renderEditProfile = function () {
      //   $('#janrainCaptureWidget').hide();
      //   $('#janrainCaptureWidget .janrain-capture-ui').hide();
      //
      //   this.checkJanrainModalReady(function () {
      //     if (janrain.capture.ui.hasActiveSession()) {
      //       $window.janrain.capture.ui.renderScreen('editProfile');
      //     }
      //   });
      // };

      this.renderLogin = function (loginRedirect, loginReason, sessionExpired) {
        var thisVariable = this;
        flowMaintenanceService.getPreferencesBeforeLogin().then(function () { // FUSS-1663 Maintenance page before login
          if (flowMaintenanceService.flowDetail.isSwitchForLogin) {
            $state.go('loginError');
            flowMaintenanceService.resetFlowDetails();
          } else {
            preLoginCheck(thisVariable, loginReason, sessionExpired);
          }
        }, function () {
          preLoginCheck(thisVariable, loginReason, sessionExpired);
        });
      };

      // this.renderForgotPass = function (loginRedirect) {
      //   this.checkJanrainModalReady(function () {
      //     console.log('render login from janrain service');
      //     if (janrain.capture.ui.hasActiveSession() && loginRedirect == 'dashboard') {
      //       $state.go('myAccount.overview');
      //     } else {
      //       // if (!janrain.capture.ui.hasActiveSession())
      //       /* make sure translations are loaded */
      //       $translate('global.error.postBack.50000')
      //         .then(function (translatedValue) {
      //           $window.janrain.capture.ui.renderScreen('forgotPassword');
      //         });
      //
      //     }
      //   });
      // };

      this.easyLoginRedirect = function (loginReason, sessionExpired) {
        if (loginReason === 'reload') {
          $state.reload('signin');
        } else if (loginReason === 'RIVERPAGE') {
          window.document.location.href = '/consumer/easyloginriverpage?showModal=true' + (sessionExpired ? '&sessionExpired=true' : '');
        } else if (!loginReason || (loginReason === 'USER_NOT_LOGGED_IN' || loginReason === 'SSO')) {
          $state.go('signin');
        } else if (loginReason === 'CHECK_AVAILABILITY_MODAL') {
          $location.url('/signin?showModal=true&redirectToState=internet');
        }
      };

      function preLoginCheck(_this, loginReason, sessionExpired) {
        if (window.localStorage && /Safari/.test(window.navigator.userAgent)) {
          try {
            window.localStorage.setItem('private', 1);
          } catch (e) {
            uteModal.open({
              templateUrl: 'modules/user/views/private-error-modal.html',
              ok: function () {
              }
            });
            return;
          }
          window.localStorage.removeItem('private');
        }

        if ($rootScope.ruiMethods && $rootScope.ruiMethods.user && $rootScope.ruiMethods.user.is.agent()) {
          env.sessionTimeoutEnabled = false;
        }
        $translate('global.error.postBack.50000')
          .then(function () {
            // Delete Lithium cookie during login
            document.cookie = 'lithiumSSO:fido=; path=/; domain=.fido.ca; expires=' + new Date(0).toUTCString();
            _this.easyLoginRedirect(loginReason, sessionExpired);
          });
      }
    }]);
})();
